// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Schedule from './pages/Schedule';
import CrewFormation from './pages/CrewFormation';
import Registration from './pages/Registration';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';        // ⬅️ détail article
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import CrewFormationForm from './pages/CrewFormationForm';
import ScrollToTop from './components/ScrollToTop';
import Cancel from './pages/Cancel';
import CancellationResult from "./pages/CancellationResult";
import CrewAudition from './pages/CrewAudition';

// ⬇️ NOUVEAU : page Paiement (coordonnées virement)
import Paiement from './pages/Paiement';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReglesEcole from './pages/ReglesEcole';

// ⬇️ Bouton remonter en haut (déjà présent dans ton app)
import ScrollToTopButton from './components/ScrollToTopButton';

import PaiementRetour from './pages/PaiementRetour';

// ⬇️ Bannière vacances (se masque automatiquement après la date de reprise)
import HolidayBanner from './components/HolidayBanner';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <HolidayBanner />
      <Navbar />
      <div className="content" style={{ minHeight: '80vh', padding: '20px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/horaires" element={<Schedule />} />
          <Route path="/formation-crew" element={<CrewFormation />} />
          <Route path="/inscription-formation" element={<CrewFormationForm />} />
          <Route path="/inscription" element={<Registration />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          {/* détail par slug OU par id */}
          <Route path="/blog/:slugOrId" element={<BlogPost />} />

          {/* Annulation */}
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/cancelled" element={<CancellationResult />} />
          <Route path="/cancellation-result" element={<CancellationResult />} />
          <Route path="/paiement" element={<Paiement />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ProductDetail />} />

          <Route path="/audition-crew" element={<CrewAudition />} />

          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/reglement-ecole" element={<ReglesEcole />} />
          <Route path="/paiement/retour" element={<PaiementRetour />} />
        </Routes>
      </div>

      {/* ⬇️ Bouton flottant visible après scroll */}
      <ScrollToTopButton />

      <Footer />
    </Router>
  );
}

export default App;